module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Valor")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditValor) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditValor
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "money",
      rawName: "v-money",
      value: ('money'),
      expression: "'money'"
    }],
    attrs: {
      "label": "Estimativa do valor do imóvel",
      "name": "estimativa_valor",
      "data-vv-as": "estimativa do valor do imóvel",
      "error-messages": _vm.errors.has('estimativa_valor') ? _vm.errors.first('estimativa_valor') : []
    },
    model: {
      value: (_vm.form.fields.estimativa_valor),
      callback: function($$v) {
        _vm.form.fields.estimativa_valor = $$v
      },
      expression: "form.fields.estimativa_valor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.dataMenu),
      callback: function($$v) {
        _vm.dataMenu = $$v
      },
      expression: "dataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data da estimativa",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.estimativa_data_formatada),
      callback: function($$v) {
        _vm.form.fields.estimativa_data_formatada = $$v
      },
      expression: "form.fields.estimativa_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.estimativa_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.estimativa_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.estimativa_data),
      callback: function($$v) {
        _vm.form.fields.estimativa_data = $$v
      },
      expression: "form.fields.estimativa_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: ('money'),
      expression: "'money'"
    }],
    attrs: {
      "label": "Valor do m² da região",
      "name": "regiao_valor"
    },
    model: {
      value: (_vm.form.fields.regiao_valor),
      callback: function($$v) {
        _vm.form.fields.regiao_valor = $$v
      },
      expression: "form.fields.regiao_valor"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('ButtonsObservacoesAnexos')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6af34edd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/DetalhesValor.vue
// module id = 1024
// module chunks = 1